<route>
{
  "name": "logout",
  "meta": {
    "order": 7,
    "isVisible": false,
    "iconName": "mdi-logout-variant",
    "artwork": "/img/samples/auth-artwork.png"
  }
}
</route>
<template>
  <h1>Logout</h1>
</template>
<script>
export default {
  layout: 'twoside',
  created () {
    this.$store.dispatch('auth/logout')
      .then(() => {
        this.$router.push({ name: 'login' })
      })
  }
}
</script>
